export const DOSSIER_OVERZICHT_QUERY_KEY = "dossier-overzicht";

export type DossierOverzichtStatus = "Open" | "Gesloten";

export const dossierOverzichtQueryKey = (status: DossierOverzichtStatus) =>
    [DOSSIER_OVERZICHT_QUERY_KEY, status] as const;
